export default __webpack_public_path__ + "static/media/product-03 (1).aca47834.jpg";